<button matRipple mat-fab extended [attr.content-type]="contentType" [type]="type" class="fab">
    <mat-icon class="arrow-icon">{{icon}}</mat-icon>
    <span>{{title}}</span>
</button>
